module.exports = __webpack_public_path__ + "img/login_logo1.40926c3c.png";